import { getAdminUser } from "../utils/auth";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL || "https://api.trivomtara.com/api"
).replace(/\/$/, "");

const SERVER_ORIGIN = API_BASE_URL.replace(/\/api$/, "");

export function getOnlineClassImageUrl(imagePath) {
  if (!imagePath) return null;
  if (String(imagePath).startsWith("http")) return imagePath;
  return `${SERVER_ORIGIN}${imagePath.startsWith("/") ? "" : "/"}${imagePath}`;
}

/** Playback URL for class video (stream API — not a direct download link). */
export function getOnlineClassVideoUrl(videoPath) {
  if (!videoPath) return null;
  if (String(videoPath).startsWith("http")) return videoPath;
  if (String(videoPath).startsWith("/api/")) {
    return `${SERVER_ORIGIN}${videoPath}`;
  }
  return `${API_BASE_URL}${videoPath.startsWith("/") ? "" : "/"}${videoPath}`;
}

function authHeaders(isJson = false) {
  const user = getAdminUser();
  const headers = {};
  if (isJson) headers["Content-Type"] = "application/json";
  if (user?.token) headers.Authorization = `Bearer ${user.token}`;
  return headers;
}

async function request(path, options = {}, fallback = "Request failed") {
  const res = await fetch(`${API_BASE_URL}${path}`, options);
  let data;
  try {
    data = await res.json();
  } catch (_err) {
    throw new Error(`${fallback} (${res.status})`);
  }
  if (!res.ok || !data.success) {
    throw new Error(data.message || fallback);
  }
  return data.data;
}

export const onlineClassApi = {
  list(params = {}) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value != null && value !== "") query.set(key, String(value));
    });
    const qs = query.toString();
    return request(
      `/online-classes${qs ? `?${qs}` : ""}`,
      { headers: authHeaders() },
      "Failed to load classes"
    );
  },
  getOne(id) {
    return request(
      `/online-classes/${id}`,
      { headers: authHeaders() },
      "Failed to load class"
    );
  },
  create(formData) {
    return request(
      "/online-classes",
      { method: "POST", headers: authHeaders(), body: formData },
      "Failed to create class"
    );
  },
  update(id, formData) {
    return request(
      `/online-classes/${id}`,
      { method: "PUT", headers: authHeaders(), body: formData },
      "Failed to update class"
    );
  },
  cancel(id) {
    return request(
      `/online-classes/${id}`,
      { method: "DELETE", headers: authHeaders() },
      "Failed to cancel class"
    );
  },
  start(id) {
    return request(
      `/online-classes/${id}/start`,
      { method: "POST", headers: authHeaders(true), body: "{}" },
      "Failed to start class"
    );
  },
  end(id) {
    return request(
      `/online-classes/${id}/end`,
      { method: "POST", headers: authHeaders(true), body: "{}" },
      "Failed to end class"
    );
  },
  attendance(id) {
    return request(
      `/online-classes/${id}/attendance`,
      { headers: authHeaders() },
      "Failed to load attendance"
    );
  },
};
